import React, { useEffect, useState } from "react";
import { iniciarSesionService } from "../services/authService";

const FormularioLogin = ({ onInicioSesion, onVolverConsulta }) => {
    const handleLogout = () => {
        // Puedes agregar lógica adicional antes de cerrar sesión
        onVolverConsulta(); // Cambiar estado en el componente padre
    };
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const hashPassword = async (password) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(password);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const hashedPassword = await hashPassword(password);
            const response = await iniciarSesionService(username, hashedPassword);

            localStorage.setItem("user", JSON.stringify({ username, tipo: response.tipo }));

            onInicioSesion(response.tipo);
        } catch (error) {
            alert(error.message);
        }
    };

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser) {
            // Notifica que el usuario ya inició sesión
            onInicioSesion(storedUser.tipo);
        }
    }, []);

    return (
        <form onSubmit={handleSubmit} className="componente" >
            <div className="card shadow-lg p-3 mb-5 bg-white rounded">
                <div className="card-body">
                    <h2 className="text-center mb-4">Iniciar Sesión</h2>
                    <div className="mb-3">
                        <input
                            type="text"
                            placeholder="Usuario"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="form-control"
                            aria-label="Usuario"
                        />
                    </div>
                    <div className="mb-3">
                        <input
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control"
                            aria-label="Contraseña"
                        />
                    </div>
                    <div className="d-flex justify-content-between">
                        <button type="submit"
                            className="btn btn-consulta ms-1"
                        >
                            Iniciar sesión
                        </button>
                        <button className="btn btn-danger ms-1" onClick={handleLogout}>
                            Volver a Consulta
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default FormularioLogin;
